import { deprecated } from 'typesafe-actions'
import { Notification } from '../../components/NotificationContainer'
import { IAppError } from '../../interfaces/base'

const { createAction } = deprecated

export const showNotification = createAction(
  'ui/SHOW_NOTIFICATION',
  (resolve) => {
    return (notification: Notification) => resolve(notification)
  },
)

export const closeNotification = createAction(
  'ui/CLOSE_NOTIFICATION',
  (resolve) => {
    return (id: string) => resolve(id)
  },
)

export const error = createAction('ui/ERROR', (resolve) => {
  return (err: IAppError) => resolve(err)
})

export const apiServerError = createAction('ui/API_SERVER_ERROR', (resolve) => {
  return (err: IAppError) => resolve(err)
})
